export const constants = {
    thisCdn: 'https://cdn.jsdelivr.net/gh/biologicalrecordscentre/brc-charts@latest/dist'
}